@if (compact) {
  <!-- ===== コンパクトモード：入力フィールドの横に並べる用 ===== -->
  <div class="upload-compact">
    <label class="compact-trigger" [class.has-file]="selectedFile()">
      <input
        type="file"
        (change)="onFileSelected($event)"
        accept=".csv,.txt,.json"
        class="hidden-file-input"
      />
      <span class="compact-icon">📎</span>
      <span class="compact-label">
        {{ selectedFile() ? selectedFile()!.name : 'ファイルを選択' }}
      </span>
    </label>

    @if (selectedFile()) {
      <button
        type="button"
        class="compact-action-btn upload"
        (click)="onSubmit()"
        [disabled]="isUploading() || isDownloading()"
      >
        @if (isUploading()) {
          <span class="compact-spinner"></span>
        } @else {
          ↑ アップロード
        }
      </button>
    }

    <button
      type="button"
      class="compact-action-btn download"
      (click)="onDownload()"
      [disabled]="isUploading() || isDownloading() || !pathForApi()"
      title="ダウンロード"
    >
      @if (isDownloading()) {
        <span class="compact-spinner"></span>
      } @else {
        ↓ ダウンロード
      }
    </button>

    @if (uploadSuccess()) {
      <span class="compact-badge success" title="アップロード完了">✅ 完了</span>
    }

    @if (error()) {
      <span class="compact-badge error" [title]="error()!">⚠️ エラー</span>
    }
  </div>

} @else {
  <!-- ===== フルモード（後方互換） ===== -->
  <div class="upload-container glass-card">
    <h2>File Transfer</h2>

    <div class="upload-form">
      <div class="form-group">
        <label for="fileSystemId">ターゲットパス</label>
        <input
          type="text"
          id="fileSystemId"
          [(ngModel)]="fileSystemId"
          placeholder="例: katori/test/gameList.csv"
          class="form-control"
        />
      </div>

      <div class="form-group file-group">
        <label for="fileInput" class="file-label">
          <span class="btn-select">Select File</span>
          <span class="file-name">{{ selectedFile()?.name || 'No file chosen' }}</span>
        </label>
        <input
          type="file"
          id="fileInput"
          (change)="onFileSelected($event)"
          accept=".csv,.txt"
          class="hidden-input"
        />
      </div>

      <div class="form-actions">
        <button
          type="button"
          class="btn-primary upload"
          (click)="onSubmit()"
          [disabled]="isUploading() || isDownloading() || !selectedFile() || !pathForApi()"
        >
          {{ isUploading() ? 'Uploading...' : 'Upload File' }}
        </button>

        <button
          type="button"
          class="btn-secondary download"
          (click)="onDownload()"
          [disabled]="isUploading() || isDownloading() || !pathForApi()"
        >
          {{ isDownloading() ? 'Downloading...' : 'Download File' }}
        </button>
      </div>
    </div>

    @if (error()) {
      <div class="alert error-toast">
        <span class="icon">⚠️</span> {{ error() }}
      </div>
    }

    @if (uploadSuccess()) {
      <div class="alert success-toast">
        <span class="icon">✅</span> File uploaded successfully!
      </div>
    }
  </div>
}
